import { RestClientError } from '@sbercloud/ft-rest-client';

import { equals } from '@/utils/common';

import { CANCELED_ERROR } from './constants';

export function isRequestCancelled(error: Error | RestClientError | unknown) {
  return (
    error instanceof RestClientError &&
    (equals(error.code, CANCELED_ERROR.code) || equals(error.message, CANCELED_ERROR.message))
  );
}

export const isFailedReq = (status: number, errorStatuses: Record<number, string>) =>
  (Object.keys(errorStatuses) as unknown as number[]).includes(status);

const SPAN_ID_BYTES = 8;
const TRACE_ID_BYTES = 16;
const SHARED_CHAR_CODES_ARRAY = Array(32);
const TRACEPARENT_VERSION = '00';
const TRACEPARENT_FLAGS = '01';

function generateId(bytes: number) {
  for (let i = 0; i < bytes * 2; i++) {
    SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
    // valid hex characters in the range 48-57 and 97-102
    if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
      SHARED_CHAR_CODES_ARRAY[i] += 39;
    }
  }
  return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
}

export function getTraceParent() {
  const traceId = generateId(TRACE_ID_BYTES);
  const spanId = generateId(SPAN_ID_BYTES);

  return `${TRACEPARENT_VERSION}-${traceId}-${spanId}-${TRACEPARENT_FLAGS}`;
}
